import { render, staticRenderFns } from "./UploadedFileStatuses.vue?vue&type=template&id=dbdcc7bc&scoped=true"
import script from "./UploadedFileStatuses.vue?vue&type=script&lang=js"
export * from "./UploadedFileStatuses.vue?vue&type=script&lang=js"
import style0 from "./UploadedFileStatuses.vue?vue&type=style&index=0&id=dbdcc7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdcc7bc",
  null
  
)

export default component.exports